import QueryString from "query-string";
import { all, call, put, select, takeEvery } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert, successAlert } from "../Alerts/actions";
import {
  addReviewsFailure,
  //
  addReviewsSuccess,
  deleteReviewsFailure,
  //
  deleteReviewsSuccess,
  editReviewsFailure,
  //
  editReviewsSuccess,
  fetchReviews as fetchReviewsAction,
  fetchReviewsFailure,
  fetchReviewsSuccess,
  //
  getViewData as getViewDataAction,
  getViewDataFailure,
  getViewDataSuccess,
  //
  addReplySuccess,
  addReplyFailure,
  //
  editReplySuccess,
  editReplyFailure,
  //
  deleteReplySuccess,
  deleteReplyFailure,
  //
  reqReviseSuccess,
  reqReviseFailure,
  //
  getImageSuccess,
  getImageFailure,
  //
  addReviewCardSuccess,
  addReviewCardFailure,
  //
  fetchUploads,
  fetchUploadsSuccess,
  fetchUploadsFailure,
} from "./actions";
import {
  ADD_REVIEWS,
  DELETE_REVIEWS,
  EDIT_REVIEWS,
  FETCH_REVIEWS,
  GET_VIEW_DATA,
  ADD_REPLY,
  EDIT_REPLY,
  DELETE_REPLY,
  REQ_REVISE,
  GET_IMAGE,
  ADD_REVIEW_CARD,
  FETCH_UPLOADS,
} from "./constants";
import { setRevFetchter } from "../Filter/actions";

export function* fetchReviewsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(api(token).get, `/api/review?${query}`);
    yield put(fetchReviewsSuccess(data));
    yield put(setRevFetchter(true));
  } catch (e) {
    yield put(fetchReviewsFailure());
    yield put(setRevFetchter(true));
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching reviews!"));
  }
}

export function* getViewDataSaga({ payload, onGetSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const { data } = yield call(api(token).get, `/api/review/${payload}`);
    yield put(getViewDataSuccess(data));
    typeof onGetSuccess === "function" && onGetSuccess(data);
  } catch (e) {
    yield put(getViewDataFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching data!"));
  }
}

export function* addReviewsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/review/add`, payload.data);
    if (data) {
      yield put(successAlert("Review added successfully!"));
      yield put(addReviewsSuccess());
      if (payload?.history) {
        payload.history.push(
          `/d/location/edit/${payload?.location_id}/reviews`
        );
      }
    }
  } catch (e) {
    yield put(addReviewsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editReviewsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/review/edit/${payload.id}`,
      payload.data
    );
    if (data) {
      yield put(successAlert("Review updated successfully!"));
      yield put(editReviewsSuccess());
      yield put(getViewDataAction(payload.id));
    }
  } catch (e) {
    yield put(editReviewsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteReviewsSaga({ payload }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/review/${payload}`);
    if (data) {
      yield put(successAlert("Review deleted successfully!"));
      yield put(deleteReviewsSuccess());
      yield put(fetchReviewsAction());
    }
  } catch (e) {
    yield put(deleteReviewsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* addReplySaga({ payload, onAdd }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).post, `/api/review-reply/add`, payload);
    if (data) {
      yield put(successAlert("Reply added successfully!"));
      yield put(addReplySuccess());
      typeof onAdd == "function" && onAdd();
    }
  } catch (e) {
    yield put(addReplyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* editReplySaga({ payload, onEdit }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/review-reply/edit/${payload.id}`,
      payload
    );
    if (data) {
      yield put(successAlert("Reply updated successfully!"));
      yield put(editReplySuccess());
      typeof onEdit == "function" && onEdit();
    }
  } catch (e) {
    yield put(editReplyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* deleteReplySaga({ payload, onDelete }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(api(token).delete, `/api/review-reply/${payload}`);
    if (data) {
      yield put(successAlert("Reply deleted successfully!"));
      yield put(deleteReplySuccess());
      typeof onDelete == "function" && onDelete();
    }
  } catch (e) {
    yield put(deleteReplyFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* reqReviseSaga({ payload, onReq }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/ask-to-revise/${payload.id}`,
      payload?.data
    );
    if (data) {
      yield put(
        successAlert(
          "Request raised successfully. We will send an email to the customer soon."
        )
      );
      yield put(reqReviseSuccess());
      typeof onReq == "function" && onReq();
    }
  } catch (e) {
    yield put(reqReviseFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* getImageSaga({ payload, onImageSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  let query = payload ? QueryString.stringify(payload) : "";
  try {
    const res = yield call(
      api(token, null, false, true).get,
      `/api/resize-file/?${query}`
    );
    const url = URL.createObjectURL(new Blob([res]));
    yield put(getImageSuccess(url));
    typeof onImageSuccess === "function" && onImageSuccess();
  } catch (e) {
    yield put(getImageFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while generating image!"));
  }
}

export function* addReviewCardSaga({ payload, onSuccess }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  try {
    const data = yield call(
      api(token).post,
      `/api/store-review-card`,
      payload.data
    );
    typeof onSuccess == "function" && onSuccess();

    if (data) {
      yield put(successAlert("Review card uploaded successfully!"));
      yield put(addReviewCardSuccess());
      yield put(
        fetchUploads({
          page: 1,
          location_id: payload?.location_id ?? "",
          limit: 10,
        })
      );
    }
  } catch (e) {
    yield put(addReviewCardFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
  }
}

export function* fetchUploadsSaga({ payload = { cancelToken: null } }) {
  const token = yield select((state) => state?.AuthReducer?.token);

  let query = payload ? QueryString.stringify(payload?.data) : "";
  try {
    const { data } = yield call(
      api(token).get,
      `/api/index-review-card?${query}`
    );
    yield put(fetchUploadsSuccess(data));
  } catch (e) {
    yield put(fetchUploadsFailure());
    if (typeof e === "string") yield put(errorAlert(e));
    else if (typeof e.error === "string") yield put(errorAlert(e.error));
    else if (e.message !== undefined)
      yield put(errorAlert("Error while fetching list!"));
  }
}

export function* fetchReviewsFlow() {
  yield takeEvery(FETCH_REVIEWS, fetchReviewsSaga);
}
export function* getViewDataFlow() {
  yield takeEvery(GET_VIEW_DATA, getViewDataSaga);
}
export function* addReviewsFlow() {
  yield takeEvery(ADD_REVIEWS, addReviewsSaga);
}
export function* editReviewsFlow() {
  yield takeEvery(EDIT_REVIEWS, editReviewsSaga);
}
export function* deleteReviewsFlow() {
  yield takeEvery(DELETE_REVIEWS, deleteReviewsSaga);
}
export function* addReplyFlow() {
  yield takeEvery(ADD_REPLY, addReplySaga);
}
export function* editReplyFlow() {
  yield takeEvery(EDIT_REPLY, editReplySaga);
}
export function* deleteReplyFlow() {
  yield takeEvery(DELETE_REPLY, deleteReplySaga);
}
export function* reqReviseFlow() {
  yield takeEvery(REQ_REVISE, reqReviseSaga);
}
export function* getImageFlow() {
  yield takeEvery(GET_IMAGE, getImageSaga);
}
export function* addReviewCardFlow() {
  yield takeEvery(ADD_REVIEW_CARD, addReviewCardSaga);
}
export function* fetchUploadsFlow() {
  yield takeEvery(FETCH_UPLOADS, fetchUploadsSaga);
}

export default function* ReviewsSaga() {
  yield all([
    fetchReviewsFlow(),
    addReviewsFlow(),
    editReviewsFlow(),
    deleteReviewsFlow(),
    getViewDataFlow(),
    addReplyFlow(),
    editReplyFlow(),
    deleteReplyFlow(),
    reqReviseFlow(),
    getImageFlow(),
    addReviewCardFlow(),
    fetchUploadsFlow(),
  ]);
}
